import { Inbox } from 'lucide-react'

interface Props {
  message?: string
  icon?: boolean
}

export default function EmptyState({ message = 'Keine Daten vorhanden', icon = false }: Props) {
  return (
    <div className="text-center py-10 text-gray-500 text-[0.84rem]">
      {icon && <Inbox className="w-10 h-10 text-gray-300 mx-auto mb-3" />}
      {message}
    </div>
  )
}
